import { 
    gql, 
    useMutation 
} from "@apollo/client";
import { 
    ResetCustomerPasswordAdminMutationMutation,
    ResetCustomerPasswordAdminMutationMutationVariables 
} from "../../../../../schemaTypes";

export const RESET_CUSTOMER_PASSWORD_ADMIN_MUTATION = gql`
  mutation ResetCustomerPasswordAdminMutation($id: String!) {
    resetCustomerPasswordAdmin(id: $id) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface Props {
  children: (
    data: {
      submit: (
        values: ResetCustomerPasswordAdminMutationMutationVariables
      ) => Promise<{
        errors: { path: string; message: string }[] | null;
        message: string | null;
      } | null>;
      loading: boolean;
      error?: Error;
    }
  ) => React.ReactElement | null;
}

export const ResetCustomerPasswordAdminController: React.FC<Props> = ({ children }) => {
  const [resetCustomerPasswordAdmin, { loading, error }] = useMutation<
    ResetCustomerPasswordAdminMutationMutation,
    ResetCustomerPasswordAdminMutationMutationVariables
  >(RESET_CUSTOMER_PASSWORD_ADMIN_MUTATION);

  const submit = async (values: ResetCustomerPasswordAdminMutationMutationVariables) => {
    try {
      const { data } = await resetCustomerPasswordAdmin({ variables: values });
      if (data?.resetCustomerPasswordAdmin) {
        return {
          errors: data.resetCustomerPasswordAdmin.errors
            ? data.resetCustomerPasswordAdmin.errors
                .filter((e): e is { path: string; message: string } => e !== null)
                .map(({ path, message }) => ({ path, message }))
            : null,
          message: data.resetCustomerPasswordAdmin.message ?? null,
        };
      }
      return null;
    } catch {
      return null;
    }
  };

  return children({ submit, loading, error });
};